import React, { useCallback } from 'react';
import { Badge, Col, Row } from 'reactstrap';
import moment from 'moment';
import _ from 'lodash';
import { formatDate } from '../../../../utils';

const checkType = [{ key: 0, type: "none" }, { key: 1, type: "warning" }, { key: 2, type: "blocking" }];

export default function TerminationApprovalPanel(props) {
    const {
        itemInEdit,
        loading,
        initialApprover,
        isApproverExists,
    } = props;

    const renderBadge = useCallback((variant) => {
        if (variant.checkResult) {
            return <Badge className="badge-circle" color="success">
                <i className="ni ni-check-bold text-white"></i>
            </Badge>
        }

        if (variant.type.key === checkType[0].key)
            return null;

        if (variant.type.key === checkType[1].key)
            return < Badge className="badge-circle" color="warning">
                <i className="fas fa-exclamation text-black"></i>
            </Badge>;

        return <Badge className="badge-circle" color="danger">
            <i className="fas fa-times text-white"></i>
        </Badge>;
    }, [isApproverExists]);

    return (
        <>
        {
            loading ?
            null
            :
            <Row className="m-0 p-0">
                <Col xs={12} className="m-0 p-0">
                    <Row className="m-0 p-0">
                        <Col xs={12} className="m-0 p-0 text-left pb-1">
                            <Row className="m-0 mt-2 p-0">
                                <Col xs={12} className="m-0 p-0">
                                    <span>Status:</span>
                                </Col>
                                <Col xs={12} className="m-0 p-0">
                                    <span>{itemInEdit?.status?.lookupValue ?? 'New'}</span>
                                </Col>
                            </Row>
                        </Col>
                    {
                        itemInEdit?.declinedReason ?
                        <Col xs={12} className="m-0 p-0 text-left pb-1">
                            <Row className="m-0 mt-2 p-0">
                                <Col xs={12} className="m-0 p-0">
                                    <span>Reject Reason:</span>
                                </Col>
                                <Col xs={12} className="m-0 p-0">
                                    <span>{itemInEdit?.declinedReason ?? "-"}</span>
                                </Col>
                            </Row>
                        </Col>
                        :
                        null
                    }
                    {
                        itemInEdit?.approverName ?
                        <Col xs={12} className="m-0 p-0 text-left pb-1">
                            <Row className="m-0 mt-2 p-0">
                                <Col xs={12} className="m-0 p-0">
                                    <span>Approver:</span>
                                </Col>
                                <Col xs={12} className="m-0 p-0">
                                    <span>{itemInEdit?.approverName ?? "-"}</span>
                                </Col>
                            </Row>
                        </Col>
                        :
                        null
                    }
                    {
                        initialApprover && !itemInEdit?.approverName ?
                        <Col xs={12} className="m-0 p-0 text-left pb-1">
                            <Row className="m-0 mt-2 p-0">
                                <Col xs={12} className="m-0 p-0">
                                    <span>Approver:</span>
                                </Col>
                                <Col xs={12} className="m-0 p-0">
                                    <span>{initialApprover ?? "-"}</span>
                                </Col>
                            </Row>
                        </Col>
                        :
                        null
                    }
                    {
                        itemInEdit?.createdBy ?
                        <Col xs={12} className="m-0 p-0 text-left pb-1">
                            <Row className="m-0 mt-2 p-0">
                                <Col xs={12} className="m-0 p-0">
                                    <span>Requested by:</span>
                                </Col>
                                <Col xs={12} className="m-0 p-0">
                                    <span>{itemInEdit?.createdBy}</span>
                                </Col>
                            </Row>
                        </Col>
                        :
                        null
                    }
                        <Col xs={12} className="m-0 p-0 text-left pb-1 mb-2">
                            <Row className="m-0 mt-2 p-0">
                                <Col xs={12} className="m-0 p-0">
                                    <span>Last Modified:</span>
                                </Col>
                                <Col xs={12} className="m-0 p-0">
                                    <span>{itemInEdit.modifiedDate ? moment(itemInEdit.modifiedDate).format("DD MMM YYYY HH:mm") : null}</span>
                                </Col>
                            </Row>
                        </Col>
                        <Col xs={12} className="m-0 p-0 text-left pb-1">
                            <Row className="m-0 mt-2 p-0">
                                <Col xs={12} className="m-0 p-0">
                                    <span>Cancellation Status:</span>
                                </Col>
                                <Col xs={12} className="m-0 p-0">
                                    <span className={itemInEdit?.cancelled ? "text-default" : ""}>{itemInEdit?.cancelled ? "Cancelled" : "-"}</span>
                                </Col>
                            </Row>
                        </Col>
                        <Col xs={12} className="m-0 p-0 text-left pb-1">
                            <Row className="m-0 mt-2 p-0">
                                <Col xs={12} className="m-0 p-0">
                                    <span>Cancellation Date:</span>
                                </Col>
                                <Col xs={12} className="m-0 p-0">
                                    <span>{itemInEdit?.cancelDate ? formatDate(moment(itemInEdit?.cancelDate), "DD.MM.YYYY") : "-"}</span>
                                </Col>
                            </Row>
                        </Col>
                    {
                        itemInEdit.projectId ?
                        <Col xs={12} className="m-0 p-0 text-left pb-1 cursor-pointer">
                            {renderBadge({ checkResult: isApproverExists, type: checkType[2] })}{" "}
                            <span className="ml-1">Approver</span>
                        </Col>
                        :
                        null
                    }
                    </Row>
                </Col>
            </Row>
        }
        </>
    );
};